import { render, staticRenderFns } from "./manage-section.html?vue&type=template&id=60266ccc&scoped=true&external"
import script from "./manage-section.js?vue&type=script&lang=js&external"
export * from "./manage-section.js?vue&type=script&lang=js&external"
import style0 from "./manage-section.scss?vue&type=style&index=0&id=60266ccc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60266ccc",
  null
  
)

export default component.exports